import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import SkipLink from '@components/SkipLink';
import styles from '@features/footer/Footer.styles';
import ContactData from '@features/footer/components/ContactData';
import { IFooter } from '@features/footer/typescript';
import General from '@features/footer/components/General';
import getImageQuality from '@utils/getImageQuality';
import LanguageSelect from './components/LanguageSelect/LanguageSelect';
export type PropsType = {
  footer: IFooter;
};
const Footer = ({
  footer
}: PropsType) => {
  const {
    socialMedia,
    chatLink,
    sectionLinks,
    payments,
    phoneNr
  } = footer;
  const actualYear = new Date().getFullYear();
  const {
    t
  } = useTranslation('layouts');
  const moreThanFivePaymentsIcons = payments?.length > 5;
  return <footer sx={styles.footerContainer}>
      <SkipLink />
      <div sx={styles.footerContainerInner}>
        <ContactData socialMedia={socialMedia} chatLink={chatLink} phoneNr={phoneNr} />
        <General sectionLinks={sectionLinks} />
        <div sx={styles.footerBottom(false)}>
          <div sx={styles.footerPayments} role="img" aria-label={t('footer.payments.acceptedMethods')}>
            {payments && payments.map(item => <div key={item.id} sx={styles.footerPaymentsIcon(item.width ? `${item.width}px` : undefined, moreThanFivePaymentsIcons)}>
                  <Image src={item.icon} fill alt={item.name || t('footer.payments.paymentMethods')} title={item.name || t('footer.payments.paymentMethods')} sizes="100px" quality={getImageQuality()} sx={{
              objectFit: 'contain'
            }} />
                </div>)}
          </div>
          <div sx={styles.footerRegionsContainer}>
            <div sx={styles.footerCopyRights}>{t('footer.rights', {
              actualYear
            })}</div>
            <LanguageSelect />
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;